import React from "react";
import { Wrapper } from "./paymentPageHeader.styles";

export default function PaymentPageHeader(props) {
  return (
    <Wrapper>
      <h2 className="heading">{props.heading}</h2>
      <p className="subheading">{props.subHeading}</p>
    </Wrapper>
  );
}
